import { render, staticRenderFns } from "./PartnersSearch.vue?vue&type=template&id=bcecdb5a&scoped=true"
import script from "./PartnersSearch.vue?vue&type=script&lang=js"
export * from "./PartnersSearch.vue?vue&type=script&lang=js"
import style0 from "./PartnersSearch.vue?vue&type=style&index=0&id=bcecdb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcecdb5a",
  null
  
)

export default component.exports